import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { Checkbox } from './../../../../../Components/Form/Checkbox'
import injectStyles from 'react-jss'
import { updateAmbassadorById } from 'Reducers/Ambassador/actions'
import { connect } from 'react-redux'
import { createUserProfileLog } from '../gql'
import { USER_PROFILE_LOGS_TYPE } from '../../../../../constants'

const styles = {
  withholdContainer: {
    position: 'absolute',
    top: 40,
    right: 40,
  },
  withoutCheckbox: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 20,
    marginLeft: 20,
  },
  withoutLabel: {
    display: 'inline-block',
    fontSize: 18,
    verticalAlign: 'middle',
    margin: 0,
    marginRight: 20,
    marginLeft: 20,
    fontWeight: 'normal',
  },
  paymentVendorInput: {
    width: '100%',
    padding: '6px 8px',
    border: '1px solid #ccc',
    borderRadius: 4,
    fontSize: 14,
  },
}

const BankDetailsSectionView = ({
  ambassadorId,
  paymentDetails,
  classes,
  updateAmbassadorById,
  withholdPay,
  fixedPriceMissions,
  logsParams,
}) => {
  const [withholdPayTrack, setWithholdPayTrack] = useState(withholdPay)
  const [fixedPriceTrack, setFixedPriceTrack] = useState(fixedPriceMissions)
  const [paymentVendor, setPaymentVendor] = useState(
    (paymentDetails && paymentDetails.paymentVendor) || '',
  )

  // Free-form payment vendor label. Saved on blur (only when it actually
  // changed) via the same updateAmbassadorById path used by the toggles above.
  const savePaymentVendor = () => {
    const current = (paymentDetails && paymentDetails.paymentVendor) || ''
    if (paymentVendor === current) return
    updateAmbassadorById(ambassadorId, { paymentVendor })
  }

  const toggleWithholdPay = async () => {
    setWithholdPayTrack(!withholdPayTrack)
    updateAmbassadorById(ambassadorId, { withhold_pay: !withholdPay })
    await createUserProfileLog(
      logsParams(
        !withholdPayTrack
          ? USER_PROFILE_LOGS_TYPE.WITHHOLD_PAY_TRUE
          : USER_PROFILE_LOGS_TYPE.WITHHOLD_PAY_FALSE,
      ),
    )
  }

  const toggleFixedPrice = async () => {
    await updateAmbassadorById(ambassadorId, {
      fixedPriceMissions: !fixedPriceMissions,
    })
    setFixedPriceTrack(!fixedPriceTrack)
    await createUserProfileLog(
      logsParams(
        !fixedPriceTrack
          ? USER_PROFILE_LOGS_TYPE.FORCE_FIXED_TRUE
          : USER_PROFILE_LOGS_TYPE.FORCE_FIXED_FALSE,
      ),
    )
  }

  return (
    <Grid fluid>
      <Row>
        <Col xs={12}>
          <SectionTitle>Bank Details</SectionTitle>
        </Col>
        <div className={classes.withholdContainer}>
          <label className={classes.withoutLabel}>
            Force fixed price missions
          </label>
          <Checkbox
            className={classes.withoutCheckbox}
            input={{
              onClick: toggleFixedPrice,
              checked: fixedPriceMissions,
            }}
            cypress_id={'forced_fixed_price_missions_checkbox'}
          />
          <span style={{ width: 50, display: 'inline-block' }} />
          <label className={classes.withoutLabel}>Withhold pay</label>
          <Checkbox
            className={classes.withoutCheckbox}
            input={{
              onClick: toggleWithholdPay,
              checked: withholdPay,
            }}
            cypress_id={'withholdPayCheckbox'}
          />
        </div>
      </Row>
      {paymentDetails && (
        <Row>
          <Col xs={3}>
            <p className="col-title">Bank Name</p>
            <p>{paymentDetails.accountName || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">BSB</p>
            <p>{paymentDetails.branchNumber || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Account Number</p>
            <p>{paymentDetails.accountNumber || '-'}</p>
          </Col>
        </Row>
      )}
      {paymentDetails && (paymentDetails.bankCountry || paymentDetails.wiseId) && (
        <Row>
          <Col xs={3}>
            <p className="col-title">Bank Country</p>
            <p>{paymentDetails.bankCountry || '-'}</p>
          </Col>
          <Col xs={3}>
            <p className="col-title">Wise tag</p>
            <p>{paymentDetails.wiseId || '-'}</p>
          </Col>
        </Row>
      )}
      {paymentDetails && (
        <Row>
          <Col xs={3}>
            <p className="col-title">Payment Vendor</p>
            <input
              className={classes.paymentVendorInput}
              type="text"
              value={paymentVendor}
              placeholder="-"
              onChange={e => setPaymentVendor(e.target.value)}
              onBlur={savePaymentVendor}
              data-cypress-id="payment_vendor_input"
            />
          </Col>
        </Row>
      )}
    </Grid>
  )
}

const StyledBankDetailsSection = injectStyles(styles)(BankDetailsSectionView)

const ConnectedBankDetailsSection = connect(
  null,
  { updateAmbassadorById },
)(StyledBankDetailsSection)

export default ConnectedBankDetailsSection
